import { assetTypes } from "../actions/asset";

const initialState = {
  isLoading: {
    assetMap: false,
    assetMapLocationAlertsLoader: false,
    assetList: false,
    map: false,
    floors: false,
    deviceTypes: false,
    deviceProfiles: false,
    singleDeviceType: false,
    location: false,
    deviceNames: false,
    deviceCountFromGateway: false,
  },
  isRefresh: false,
  singleDeviceType: [],
  error: null,
  ui: {
    notification: {
      isActive: false,
      type: "success",
      message: "",
      description: "",
      style: { backgroundColor: "#d4edda", color: "#155724" },
    },
    formData: {
      selectedStep: 1,
      step1: {
        errors: {
          assetName: false,
        },
        assetName: "",
        description: "",
      },
      step2: {
        errors: {
          deviceType: false,
          deviceId: false,
          deviceProfile: false,
        },
        deviceTypes: [],
        deviceNames: [],
        deviceProfiles: [],
        deviceType: "",
        deviceId: "",
        deviceProfile: "",
      },
      step3: {
        zone: "",
        assetType: "",
        assetModel: "",
        assetSerialNumber: "",
        assetOwner: "",
      },
    },
    location: {
      temperature: "",
      battery: "",
      datatimestamp: "",
      currentIndex: 0,
    },
    opType: null,
    selectedAsset: null,
    selectedLocation: null,
    isFloorView: false,
    floorView: {
      isLoading: false,
      height: "450px",
      scale: 1.25,
      isDragging: false,
      translateX: 0,
      translateY: 0,
      selectedIndex: 0,
    },
  },
  filters: {
    assetstatus: {
      sort: "",
      option: [
        // {
        //   text: "Active",
        //   value: "header",
        // },
        {
          text: "No Alert",
          value: false,
        },
        {
          text: "Warning",
          value: false,
        },
        {
          text: "Critical",
          value: false,
        },
        {
          text: "Notification",
          value: false,
        },
        // {
        //   text: "Inactive",
        //   value: "header",
        // },
        // {
        //   text: "Completed",
        //   value: false,
        // },
      ],
    },
    assetname: {
      sort: "asc",
      option: "",
    },
    assetid: {
      sort: "asc",
      option: "",
    },
    devicename: {
      sort: "asc",
      option: "",
    },
    location: {
      sort: "asc",
      option: "",
    },
    locationzone: { sort: "asc", option: "" },
    updatedat: {
      sort: "asc",
      option: {
        lastupdatedfrom: "",
        lastupdatedto: "",
      },
    },
  },
  data: {
    selectedTabIndex: 0,
    pageSize: 10,
    currentPage: 1,
    count: 0,
    assetList: [],
    allAssetsListData: [],
    deviceDetails: {},
    address: "",
    uniqueLocations: [],
    map: [],
    floors: [
      {
        image: "/assets/vfloor.png",
        width: 800,
        height: 448,
        name: "Floor 1",
        id: "floor1",
        count: 1, // Number of assets on this floor
        assets: [
          {
            type: "warning",
            color: "#FF8027",
            id: "asset1",
            name: "Asset 1",
            count: 1,
            x: 100,
            y: 100,
          },
          {
            type: "info",
            color: "#0089EC",
            id: "asset2",
            name: "Asset 2",
            count: 2,
            x: 200,
            y: 200,
          },
          {
            type: "success",
            color: "#00B140",
            id: "asset3",
            name: "Asset 3",
            count: 3,
            x: 300,
            y: 300,
          },
          {
            type: "error",
            color: "#FF0000",
            id: "asset4",
            name: "Asset 4",
            count: 4,
            x: 400,
            y: 400,
          },
        ], // Array to hold asset data for this floor
        isLoading: false, // Loading state for assets
        scale: 1, // Initial zoom level
        translateX: 0, // Initial horizontal translation
        translateY: -50, // Initial vertical translation
        isDragging: false, // State to check if the canvas is being dragged
      },
      {
        image: "/assets/floor2.png",
        width: 800,
        height: 448,
        name: "Basement",
        id: "basement",
        count: 1, // Number of assets on this floor
        assets: [
          {
            type: "warning",
            color: "#FF8027",
            id: "asset1",
            name: "Asset 1",
            count: 1,
            x: 100,
            y: 100,
          },
          {
            type: "info",
            color: "#0089EC",
            id: "asset2",
            name: "Asset 2",
            count: 2,
            x: 200,
            y: 200,
          },
          {
            type: "success",
            color: "#00B140",
            id: "asset3",
            name: "Asset 3",
            count: 3,
            x: 300,
            y: 300,
          },
          {
            type: "error",
            color: "#FF0000",
            id: "asset4",
            name: "Asset 4",
            count: 4,
            x: 400,
            y: 400,
          },
        ], // Array to hold asset data for this floor
        isLoading: false, // Loading state for assets
        scale: 1, // Initial zoom level
        translateX: 0, // Initial horizontal translation
        translateY: -70, // Initial vertical translation
        isDragging: false, // State to check if the canvas is being dragged
      },
    ],
    query: {
      $sort: [{ field: "createdon", order: "desc" }],
    },
  },
  assetTrackData: [],
};

const assetReducer = (state = initialState, action) => {
  switch (action.type) {
    case assetTypes.FETCH_REQUEST: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetList: true,
          assetMap: true,
        },
        ui: {
          ...state.ui,
          //selectedLocation: null,
          selectedAsset: null,
        },
      };
    }
    case assetTypes.FETCH_ALL_ASSETS_FOR_MAP_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data,
        },
        isLoading: {
          ...state.isLoading,
          assetMap: false,
        },
      };
    case assetTypes.SAVE_PREVIOUS_FILTERS:
      return {
        ...state,
        previousFilters: action.payload,
      };
    case assetTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetList: false,
        },
        ui: {
          ...state.ui,
          selectedLocation: action.payload.selectedLocation
            ? action.payload.selectedLocation
            : state.ui.selectedLocation,
          floorView: action.payload.selectedLocation
            ? {
                ...state.ui.floorView,
                height: action.payload.height || "450px",
                scale: action.payload.height === "450px" ? 1.25 : 1.45,
                isDragging: false,
                translateX: 0,
                translateY: 0,
              }
            : state.ui.floorView,
        },
        data: {
          ...state.data,
          ...action.payload.data,
          query: action?.payload
            ? {
                $sort: [{ field: "createdon", order: "desc" }],
              }
            : state.data.query,
        },
        filters: {
          ...state.filters,
          // locationzone:  action.payload.selectedLocation
          //   ? {
          //       sort: "asc",
          //       option: `${action.payload.selectedLocation?.name} - ${action.payload.selectedLocation?.floors?.[0]?.name}` || "",
          //     }
          //   : state.filters.locationzone,

          // assetid: {
          //   sort: "asc",
          //   option: "",
          // },
          isLoaded: true,
        },
        error: null,
      };
    case assetTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetList: false,
          assetMap: false,
        },
        data: {
          ...state.data,
          assetList: [],
          allAssetsList: [],
        },
        error: action.payload,
      };
    case assetTypes.FETCH_DEVICE_TYPES_REQUEST: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceTypes: true,
        },
      };
    }
    case assetTypes.FETCH_SINGLE_DEVICE_TYPES_REQUEST: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          singleDeviceType: true,
        },
      };
    }
    case assetTypes.FETCH_LOCATION_ALERTS_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetMapLocationAlertsLoader: true,
        },
        ui: {
          ...state.ui,
          location: {
            address: "",
            location: [0, 0],
            temperature: "",
            battery: "",
            datatimestamp: "",
            currentIndex: 0,
          },
        },
      };
    case assetTypes.FETCH_LOCATION_ALERTS_RESPONSE:
      return {
        ...state,
        assetTrackData: [...action.payload],
        isLoading: {
          ...state.isLoading,
          assetMapLocationAlertsLoader: false,
        },
      };
    case assetTypes.FETCH_DEVICE_TYPES_SUCCESS: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceTypes: false,
        },
        ui: {
          ...state.ui,
          formData: {
            ...state.ui.formData,
            step2: {
              ...state.ui.formData.step2,
              deviceTypes: action.payload,
            },
          },
        },
        error: null,
      };
    }
    case assetTypes.FETCH_DEVICE_TYPES_FAILURE: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceTypes: false,
        },
        error: action.payload,
        ui: {
          ...state.ui,
          formData: {
            ...state.ui.formData,
            step2: {
              ...state.ui.formData.step2,
              deviceTypes: [],
            },
          },
        },
      };
    }
    case assetTypes.FETCH_SINGLE_DEVICE_TYPES_SUCCESS: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          singleDeviceType: false,
        },
        singleDeviceType: action.payload || [],
        error: null,
      };
    }
    case assetTypes.FETCH_SINGLE_DEVICE_TYPES_FAILURE: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          singleDeviceType: false,
        },
        error: action.payload,
        singleDeviceType: [],
      };
    }
    case assetTypes.FETCH_DEVICE_NAMES_REQUEST: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceNames: true,
        },
      };
    }
    case assetTypes.FETCH_DEVICE_NAMES_SUCCESS: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceNames: false,
        },
        ui: {
          ...state.ui,
          formData: {
            ...state.ui.formData,
            step2: {
              ...state.ui.formData.step2,
              deviceNames: action.payload,
            },
          },
        },
        error: null,
      };
    }
    case assetTypes.FETCH_DEVICE_NAMES_FAILURE: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceNames: false,
        },
        error: action.payload,
        ui: {
          ...state.ui,
          formData: {
            ...state.ui.formData,
            step2: {
              ...state.ui.formData.step2,
              deviceNames: [],
            },
          },
        },
      };
    }
    case assetTypes.FETCH_DEVICE_PROFILES_REQUEST: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceProfiles: true,
        },
      };
    }
    case assetTypes.FETCH_DEVICE_PROFILES_SUCCESS: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceProfiles: false,
        },
        ui: {
          ...state.ui,
          formData: {
            ...state.ui.formData,
            step2: {
              ...state.ui.formData.step2,
              deviceProfiles: action.payload,
            },
          },
        },
        error: null,
      };
    }
    case assetTypes.FETCH_DEVICE_PROFILES_FAILURE: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceProfiles: false,
        },
        error: action.payload,
        ui: {
          ...state.ui,
          formData: {
            ...state.ui.formData,
            step2: {
              ...state.ui.formData.step2,
              deviceProfiles: [],
            },
          },
        },
      };
    }
    case assetTypes.FETCH_LOCATIONS_REQUEST: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          location: true,
          uniqueLocations: true,
        },
        // ui: {
        //   ...state.ui,
        //   selectedLocation: null
        // },
      };
    }
    case assetTypes.FETCH_LOCATIONS_SUCCESS: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          location: false,
          uniqueLocations: false,
        },
        data: {
          ...state.data,
          uniqueLocations: action.payload,
        },
        ui: {
          ...state.ui,
          // selectedLocation:
          //   action.payload?.length > 0 ? action.payload[0] : state.ui.selectedLocation,
          formData: {
            ...state.ui.formData,
            step3: {
              ...state.ui.formData.step3,
              locations: action.payload,
            },
          },
        },
        error: null,
      };
    }
    case assetTypes.FETCH_LOCATIONS_FAILURE: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          location: false,
          uniqueLocations: false,
        },
        ui: {
          ...state.ui,
          //selectedLocation: null,
          formData: {
            ...state.ui.formData,
            step2: {
              ...state.ui.formData.step2,
              locations: [],
            },
          },
        },
        data: {
          ...state.data,
          uniqueLocations: [],
        },
        error: action.payload,
      };
    }
    case assetTypes.FETCH_DEVICE_COUNT_FROM_GATEWAY_REQUEST: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceCountFromGateway: true,
        },
      };
    }
    case assetTypes.FETCH_DEVICE_COUNT_FROM_GATEWAY_SUCCESS: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceCountFromGateway: false,
        },
        data: {
          ...state.data,
          //uniqueLocations: action?.payload || state.data.uniqueLocations,
        },
        error: null,
      };
    }
    case assetTypes.FETCH_DEVICE_COUNT_FROM_GATEWAY_FAILURE: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceCountFromGateway: false,
        },
        error: action.payload,
      };
    }
    case assetTypes.UPDATE_FILTERS: {
      return {
        ...state,
        isRefresh:
          typeof action.payload.isRefresh !== "undefined"
            ? action.payload.isRefresh
            : !state.isRefresh,
        filters: {
          ...state.filters,
          ...action.payload.filters,
        },
        data: {
          ...state.data,
          pageSize:
            typeof action.payload.pageSize !== "undefined"
              ? action.payload.pageSize
              : 10,
          currentPage:
            typeof action.payload.currentPage !== "undefined"
              ? action.payload.currentPage
              : 1,
          query: {
            ...state.data.query,
            $sort: action.payload.sort
              ? [
                  {
                    field: action.payload.sort.field,
                    order: action.payload.sort.order,
                  },
                ]
              : [],
          },
        },
      };
    }
    case assetTypes.CLEAR_FILTER:
      return {
        ...state,
        filters: {
          assetstatus: {
            sort: "",
            option: [
              {
                text: "No Alert",
                value: false,
              },
              {
                text: "Warning",
                value: false,
              },
              {
                text: "Critical",
                value: false,
              },
              {
                text: "Notification",
                value: false,
              },
            ],
          },
          assetid: {
            sort: "asc",
            option: "",
          },
          assetname: {
            sort: "asc",
            option: "",
          },
          devicename: {
            sort: "asc",
            option: "",
          },
          locationzone: { 
            sort: "asc", 
            option: "" 
          },
          location: {
            sort: "asc",
            option: "",
          },
          updatedat: {
            sort: "asc",
            option: {
              lastupdatedfrom: "",
              lastupdatedto: "",
            },
          },
        },
        ui: {
          ...state.ui,
          isFloorView: false,
          floorView: {
            ...state.ui.floorView,
            isLoading: false,
            height: "450px",
            scale: 1.25,
            isDragging: false,
            translateX: 0,
            translateY: 0,
            selectedIndex: 0,
          },
        },
        data: {
          ...state.data,
          pageSize: 10,
          currentPage: 1,
          query: {
            ...state.data.query,
            $sort: [{ field: "createdon", order: "desc" }],
          },
        },
      };
    case assetTypes.UPDATE_PAGE_NO:
      return {
        ...state,
        isRefresh: !state.isRefresh,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    case assetTypes.UPDATE_UI:
      return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        },
      };
    case assetTypes.CREATE_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          formData: {
            ...state.ui.formData,
            isSubmitted: true,
          },
        },
      };
    case assetTypes.DELETE_REQUEST:
      return {
        ...state,
      };
    case assetTypes.CREATE_SUCCESS:
      return {
        ...state,
        isRefresh: !state.isRefresh,
        ui: {
          ...state.ui,
          notification: {
            isActive: true,
            type: "success",
            message: "Create",
            description: "Asset created successfully",
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
          formData: {
            selectedStep: 1,
            step1: {
              errors: {
                assetName: false,
              },
              assetName: "",
              description: "",
            },
            step2: {
              errors: {
                deviceType: false,
                deviceId: false,
                deviceProfile: false,
              },
              deviceTypes: [],
              deviceNames: [],
              deviceProfiles: [],
              deviceType: "",
              deviceId: "",
              deviceProfile: "",
            },
            step3: {
              zone: "",
              assetType: "",
              assetModel: "",
              assetSerialNumber: "",
              assetOwner: "",
            },
          },
          opType: null,
          selectedAsset: null,
        },
      };
    case assetTypes.CREATE_FAILURE:
      return {
        ...state,
        error: action.payload,
        ui: {
          ...state.ui,
          notification: {
            isActive: true,
            type: "error",
            message: "Create",
            description: "Failed to create asset",
            style: { backgroundColor: "#f8d7da", color: "#721c24" },
          },
          formData: {
            selectedStep: 1,
            step1: {
              errors: {
                assetName: false,
              },
              assetName: "",
              description: "",
            },
            step2: {
              errors: {
                deviceType: false,
                deviceId: false,
                deviceProfile: false,
              },
              deviceTypes: [],
              deviceNames: [],
              deviceProfiles: [],
              deviceType: "",
              deviceId: "",
              deviceProfile: "",
            },
            step3: {
              zone: "",
              assetType: "",
              assetModel: "",
              assetSerialNumber: "",
              assetOwner: "",
            },
          },
          opType: null,
          selectedAsset: null,
        },
      };
    case assetTypes.DELETE_SUCCESS:
      return {
        ...state,
        isRefresh: !state.isRefresh,
        ui: {
          ...state.ui,
          notification: {
            isActive: true,
            type: "success",
            message: "Delete",
            description: "Asset deleted successfully",
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
          formData: {
            selectedStep: 1,
            step1: {
              errors: {
                assetName: false,
              },
              assetName: "",
              description: "",
            },
            step2: {
              errors: {
                deviceType: false,
                deviceId: false,
                deviceProfile: false,
              },
              deviceTypes: [],
              deviceNames: [],
              deviceProfiles: [],
              deviceType: "",
              deviceId: "",
              deviceProfile: "",
            },
            step3: {
              zone: "",
              assetType: "",
              assetModel: "",
              assetSerialNumber: "",
              assetOwner: "",
            },
          },
          opType: null,
          selectedAsset: null,
        },
      };
    case assetTypes.DELETE_FAILURE:
      return {
        ...state,
        error: action.payload,
        ui: {
          ...state.ui,
          notification: {
            isActive: true,
            type: "error",
            message: "Delete",
            description: "Failed to delete asset",
            style: { backgroundColor: "#f8d7da", color: "#721c24" },
          },
          formData: {
            selectedStep: 1,
            step1: {
              errors: {
                assetName: false,
              },
              assetName: "",
              description: "",
            },
            step2: {
              errors: {
                deviceType: false,
                deviceId: false,
                deviceProfile: false,
              },
              deviceTypes: [],
              deviceNames: [],
              deviceProfiles: [],
              deviceType: "",
              deviceId: "",
              deviceProfile: "",
            },
            step3: {
              zone: "",
              assetType: "",
              assetModel: "",
              assetSerialNumber: "",
              assetOwner: "",
            },
          },
          opType: null,
          selectedAsset: null,
        },
      };
    case assetTypes.UPDATE_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          formData: {
            ...state.ui.formData,
            isSubmitted: true,
          },
        },
      };
    case assetTypes.UPDATE_SUCCESS:
      return {
        ...state,
        isRefresh: !state.isRefresh,
        ui: {
          ...state.ui,
          notification: {
            isActive: true,
            type: "success",
            message: "Update",
            description: "Asset updated successfully",
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
          formData: {
            selectedStep: 1,
            step1: {
              errors: {
                assetName: false,
              },
              assetName: "",
              description: "",
            },
            step2: {
              errors: {
                deviceType: false,
                deviceId: false,
                deviceProfile: false,
              },
              deviceTypes: [],
              deviceNames: [],
              deviceProfiles: [],
              deviceType: "",
              deviceId: "",
              deviceProfile: "",
            },
            step3: {
              zone: "",
              assetType: "",
              assetModel: "",
              assetSerialNumber: "",
              assetOwner: "",
            },
          },
          opType: null,
          selectedAsset: null,
        },
      };
    case assetTypes.UPDATE_FAILURE:
      return {
        ...state,
        error: action.payload,
        ui: {
          ...state.ui,
          notification: {
            isActive: true,
            type: "error",
            message: "Update",
            description: "Failed to update asset",
            style: { backgroundColor: "#f8d7da", color: "#721c24" },
          },
          formData: {
            selectedStep: 1,
            step1: {
              errors: {
                assetName: false,
              },
              assetName: "",
              description: "",
            },
            step2: {
              errors: {
                deviceType: false,
                deviceId: false,
                deviceProfile: false,
              },
              deviceTypes: [],
              deviceNames: [],
              deviceProfiles: [],
              deviceType: "",
              deviceId: "",
              deviceProfile: "",
            },
            step3: {
              zone: "",
              assetType: "",
              assetModel: "",
              assetSerialNumber: "",
              assetOwner: "",
            },
          },
          opType: null,
          selectedAsset: null,
        },
      };
    case assetTypes.DOWNLOAD_IMAGE_REQUEST:
      return {
        ...state,
      };
    case assetTypes.DOWNLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          //selectedLocation: action?.payload?.selectedLocation || null,
        },
        data: {
          ...state.data,
          //uniqueLocations:action?.payload?.uniqueLocations || state.data.uniqueLocations,
        },
        error: null,
      };
    case assetTypes.DOWNLOAD_IMAGE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case assetTypes.FETCH_DEVICE_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceNames: true,
        },
      };
    case assetTypes.FETCH_DEVICE_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceNames: false,
        },
        data: {
          ...state.data,
          deviceNames: action.payload,
        },
      };
    case assetTypes.FETCH_DEVICE_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceNames: false,
        },
        error: action.payload,
      };
    case assetTypes.FLOOR_VIEW_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetList: true,
        },
        ui: {
          ...state.ui,
          floorView: {
            ...state.ui.floorView,
            isLoading: true,
            height: "450px",
            scale: 1.25,
            isDragging: false,
            translateX: 0,
            translateY: 0,
            selectedIndex: 0,
          },
          selectedLocation: action?.payload?.location,
        },
      };
    case assetTypes.FLOOR_VIEW_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetList: false,
        },
        ui: {
          ...state.ui,
          floorView: {
            ...state.ui.floorView,
            isLoading: false,
            selectedIndex: action?.payload?.floorIndex || 0,
          },
          selectedLocation: action?.payload?.selectedLocation
            ? action.payload.selectedLocation
            : state.ui.selectedLocation,
        },
        error: null,
      };
    case assetTypes.FLOOR_VIEW_FAILURE:
      return {
        ...state,
        ui: {
          ...state.ui,
          floorView: {
            ...state.ui.floorView,
            isLoading: false,
          },
        },
        error: action.payload,
      };
    default:
      return state;
  }
};

export default assetReducer;
